import { render, staticRenderFns } from "./listIndex.vue?vue&type=template&id=a36229aa&scoped=true&"
import script from "./listIndex.vue?vue&type=script&lang=js&"
export * from "./listIndex.vue?vue&type=script&lang=js&"
import style0 from "./listIndex.vue?vue&type=style&index=0&id=a36229aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36229aa",
  null
  
)

export default component.exports